/**
 * Created by Katarzyna.Zabelska on 12.06.2019.
 * Components included in OA build.
 */
import AbstractComponent from '@main/view/components/bss-abstract-component/js/bss-abstract-component.js';
import LabelComponent from '@main/view/components/bss-label-component/js/bss-label-component.js';
import CompareListComponent from '@main/view/components/bss-compare-list-component/js/bss-compare-list-component.js';
import ButtonComponent from '@main/view/components/bss-button-component/js/bss-button-component.js';
import PopupComponent from '@main/view/components/bss-popup-component/js/bss-popup-component.js';
import InfohintComponent from '@main/view/components/bss-infohint-component/js/bss-infohint-component.js';
import TemplateComponent from '@main/view/components/bss-template-component/js/bss-template-component.js';
import TableComponent from '@main/view/components/bss-table-component/js/bss-table-component.js';
export var marketComponents = {
    AbstractComponent: AbstractComponent,
    LabelComponent: LabelComponent,
    CompareListComponent: CompareListComponent,
    ButtonComponent: ButtonComponent,
    PopupComponent: PopupComponent,
    InfohintComponent: InfohintComponent,
    TemplateComponent: TemplateComponent,
    TableComponent: TableComponent,
};
